import React, { useRef, useState, useEffect, Suspense } from "react";
import { useSelector, useDispatch } from 'react-redux'
import ReactPlaceholder from "react-placeholder/lib";
import Utils from "../../../services/Utils";
import { LanguageService } from '../../../services/LanguageService'
import { LocalStorageService } from "../../../services/LocalStorageService"
import { getAnnouncements } from '../../../actions/AnnouncementsAction'
import AnnoucmentPlaceholder from "../../placeholders/AnnouncementPlaceholder";
import AnnouncementPopup from "./AnnouncementPopup";
const Slider = React.lazy(() => import("react-slick"));

const AllowedTags = ['em', 'i', 'a', 'strong', 'b']

function Announcement({ onHide }) {
  const dispatch = useDispatch();
  const announcementItems = useRef([]);
  const sliderWrapRef = useRef();
  const moreBtnRef = useRef();
  const { data = {}, loading = true } = useSelector(state => state.announcements);
  const { isLoggedIn } = useSelector(state => state.user);
  const { isLoading: isTranslationLoading = true } = useSelector(state => state.translations);
  const [activeAnnouncementText, setActiveAnnouncementText] = useState();
  const [itemsWidths, setItemsWidths] = useState({});
  const [isShowMoreBtn, setIsShowMoreBtn] = useState([]);
  const selecteLanguage = LanguageService.getSelectedLanguage() || LanguageService.getSelectedLanguageFromLocalStorage();
  const announcementSliderSettings = {
    autoplay: !!data.autoPlay,
    speed: Object.keys(data).length ? data.animationSpeed * 1000 : 500,
    fade: data.animationType === 1 ? false : true
  }
  const settings = {
    dots: false,
    infinite: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: document.body.classList.contains('tb--rtl'),
    ...announcementSliderSettings
  };


  useEffect(() => {
    dispatch(getAnnouncements(selecteLanguage)).then((res) => {
      if (!res || !res?.announcements?.filter((i) => (i.announcementContent)).length) {
        onHide()
      } else {
        const storageData = LocalStorageService.get(`announcements`);
        let data = { lastUpdateTime: res.lastUpdateTime }

        if (storageData && JSON.stringify(data) === JSON.stringify(storageData)) {
          onHide()
        }

      }
    })
  }, [isLoggedIn, selecteLanguage]);

  useEffect(() => {
    activeAnnouncementText && Utils.addOverflowHidden();
  }, [activeAnnouncementText])

  const addMoreBtn = () => {
    const padding = Utils.isTablet() ? (!data.isPermanent ? 166 : 132) : 240;
    announcementItems.current.forEach((item, i) => {
      if (!item) return;
      if (((itemsWidths[i] ? itemsWidths[i].origin : item.offsetWidth) + moreBtnRef.current.offsetWidth) > (sliderWrapRef.current.offsetWidth - padding)) {
        itemsWidths[i] = { origin: (itemsWidths[i] ? itemsWidths[i].origin : item.offsetWidth), dynamic: (sliderWrapRef.current.offsetWidth - moreBtnRef.current.offsetWidth) - (padding + (Utils.isTablet() ? 5 : 25)) };
        setItemsWidths(itemsWidths);
        isShowMoreBtn[i] = true;
        setIsShowMoreBtn([...isShowMoreBtn])
      } else {
        isShowMoreBtn[i] = false
        setIsShowMoreBtn([...isShowMoreBtn])
      }
    });
  };

  useEffect(addMoreBtn, [announcementItems.current.length, loading]);

  useEffect(() => {
    window.addEventListener('resize', addMoreBtn);
    return () => {
      window.removeEventListener('resize', addMoreBtn)
    }
  }, [])

  const hideAnnouncments = () => {
    onHide()
    storeAnnouncments()
  }

  const closeAnnouncementPopup = () => {
    Utils.removeOverflowHidden();
    setActiveAnnouncementText(null)
  }

  const storeAnnouncments = () => {
    let storedData = { lastUpdateTime: data.lastUpdateTime }
    LocalStorageService.set(`announcements`, storedData)
  }

  const sliderItems = (data?.announcements)?.filter((i) => (i.announcementContent)).map((item, i) => {
    return (
      <div className="tb--announcement-item tb--flex" key={i}>
        <span
          className="tb--announcement-item_text" style={{
            ...(itemsWidths[i] ? { width: itemsWidths[i].dynamic } : {}),
          }}
          ref={(elem) => (announcementItems.current[i] = elem)}
          dangerouslySetInnerHTML={{ __html: Utils.stripTags(decodeURIComponent(atob(item.announcementContent)), AllowedTags) }}
        >
        </span>
        <span
          className={`tb--more-btn tb--text_upercase tb--text-underline tb--block ${!isShowMoreBtn[i] ? 'tb--visibility-hidden' : ''}`}
          ref={moreBtnRef}
          onClick={() => setActiveAnnouncementText(item.announcementContent)}
        >
          {LanguageService.getTranslation('details')}
        </span>

      </div>
    );
  });

  return (
    <>
      {sliderItems ? (
        <ReactPlaceholder customPlaceholder={<AnnoucmentPlaceholder />} ready={!loading && !isTranslationLoading}>
          <div className='tb--announcement-wrapper'>
            <div ref={sliderWrapRef} className={`tb--announcement-block ${data.isPermanent ? "tb--more-padding" : ""}`}>
              <i className="digi_icon-announcment"></i>
              <Suspense fallback={<></>}>
                <Slider key={`${Object.keys(itemsWidths).length}}`}  {...settings}>{sliderItems}</Slider>
              </Suspense>
            </div>
            {data.isPermanent ? <></> : <i className="digi_icon-close" onClick={hideAnnouncments}></i>}
          </div>
        </ReactPlaceholder>
      ) : (
        <></>
      )}
      {activeAnnouncementText && (
        <AnnouncementPopup
          closePopup={() => closeAnnouncementPopup()}
          announcementText={activeAnnouncementText}
        />
      )}
    </>
  );
}

export default Announcement;
